function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_x0020_1"
}, React.createElement("metadata", {
  id: "CorelCorpID_0Corel-Layer"
}), React.createElement("path", {
  className: "fil0",
  d: "M15 249c1,4 5,12 7,15 4,1 59,35 121,50 12,3 22,5 35,7 6,1 13,2 18,3 14,1 49,4 61,3l42 -1c28,0 54,3 82,1 85,-7 127,-25 197,-62l1 -1c3,-2 5,-8 6,-12 -5,0 -7,2 -14,2 -11,1 -15,1 -28,-1 -25,-4 -40,-10 -69,-10 -4,2 -23,3 -30,4 -10,2 -19,6 -27,7 -4,2 -9,3 -13,5 -26,12 -35,19 -59,35 -8,5 -15,11 -23,16 -2,3 -20,15 -23,14 -3,0 -21,-13 -24,-15 -9,-9 -58,-39 -69,-44 -10,-5 -18,-8 -26,-11 -8,-1 -18,-5 -27,-7 -6,-1 -27,-3 -30,-4 -21,0 -37,4 -55,8 -9,2 -18,3 -27,4 -7,1 -23,-2 -28,-4z"
}), React.createElement("path", {
  className: "fil0",
  d: "M199 171c8,4 33,25 37,30 4,4 7,7 11,11 4,4 7,8 10,12 4,5 17,21 18,26 6,4 23,39 25,47l1 -1c2,-3 3,-7 4,-10 3,-7 13,-30 18,-33 2,-5 6,-10 9,-14 3,-5 6,-9 10,-13 7,-9 14,-15 22,-24 5,-6 11,-11 17,-16 5,-4 14,-12 20,-15 2,-2 10,-8 14,-9 0,-26 -1,-48 -9,-73 -2,-6 -4,-15 -7,-20 -3,2 -4,3 -7,6l-19 19 -24 28c-3,6 -9,14 -13,20 -2,3 -4,7 -6,11 -2,3 -4,8 -6,10 0,2 1,1 -1,1 -1,5 -10,24 -13,32 -3,7 -8,30 -11,34 -6,-23 -11,-39 -20,-60 -9,-21 -28,-47 -29,-50 -9,-10 -12,-16 -24,-27 -3,-3 -3,-3 -6,-7 -2,-3 -4,-4 -7,-6 -4,-4 -9,-11 -14,-12 0,3 -10,33 -13,51 -1,9 -3,21 -2,30 0,5 0,11 4,13 2,2 5,2 10,7z"
}), React.createElement("path", {
  className: "fil0",
  d: "M408 177c-1,2 -16,12 -19,15 -3,3 -6,5 -9,8 -4,3 -4,5 -9,8 0,1 -19,20 -25,29 -5,7 -22,34 -22,34 -2,7 -9,19 -11,28 4,-2 8,-6 11,-7 3,-3 6,-5 10,-7 28,-21 45,-28 76,-42 21,-6 34,-9 57,-11l18 0c16,-24 33,-62 33,-103 -20,5 -53,18 -72,27 -5,2 -8,4 -13,7 -10,6 -17,11 -25,15z"
}), React.createElement("path", {
  className: "fil0",
  d: "M134 230c15,1 46,5 57,13 13,1 75,38 85,46 5,2 9,6 15,8 -3,-10 -11,-21 -15,-31 -3,-4 -19,-31 -33,-45 -5,-5 -8,-9 -13,-14 -5,-3 -13,-11 -18,-16 -3,-3 -6,-5 -10,-8 -3,-3 -7,-4 -9,-7 -3,-1 -18,-11 -24,-14l-26 -13c-9,-4 -50,-20 -59,-20 0,17 6,40 11,56 6,18 13,31 21,46l19 0z"
}), React.createElement("path", {
  className: "fil0",
  d: "M275 15c-17,11 -28,24 -28,47 0,24 11,36 28,48 8,2 12,5 23,6 12,0 16,-2 25,-5 5,-4 14,-7 21,-18 16,-24 12,-53 -9,-71 -6,-5 -8,-5 -12,-8 -10,-2 -13,-5 -25,-5 -11,0 -14,3 -23,6z"
}));

var SvgPeaceLotus = function SvgPeaceLotus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 600 350",
    fill: "#eb5",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPeaceLotus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PeaceLotus.e7f47f62.svg";
export { ForwardRef as ReactComponent };